/**
 * @param {Array<{ product_id?: number; productId?: number; quantity?: number; properties?: Record<string, string> }>} items
 * @param {number} [prioProductId]
 * @returns {number}
 */
export function getVisibleCartItemCount(items, prioProductId = 0) {
  if (!items?.length) return 0;

  return items.reduce((sum, item) => {
    const productId = item.product_id ?? item.productId ?? 0;
    if (prioProductId && productId === prioProductId) return sum;
    if (item.properties?._prio_plus) return sum;
    return sum + (item.quantity ?? 0);
  }, 0);
}

/**
 * @param {number} count
 * @param {boolean} [animate=true]
 */
export function updateAllCartIcons(count, animate = true) {
  document.querySelectorAll('cart-icon').forEach((icon) => {
    if (icon instanceof HTMLElement && 'renderCartBubble' in icon && typeof icon.renderCartBubble === 'function') {
      icon.renderCartBubble(count, animate);
    }
  });

  const liveRegion = document.querySelector('[data-testid="cart-count-live-region"]');
  if (liveRegion instanceof HTMLElement && Theme?.translations?.cart_count) {
    liveRegion.textContent = `${Theme.translations.cart_count}: ${count}`;
  }
}

/**
 * @param {number} [prioProductId]
 * @returns {Promise<number>}
 */
export async function fetchVisibleCartItemCount(prioProductId = 0) {
  const response = await fetch(`${Theme.routes.cart_url}.json`);
  if (!response.ok) return 0;

  const cart = await response.json();
  return getVisibleCartItemCount(cart.items, prioProductId);
}
